var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "token-list-wrapper" }, [
    _c("div", { staticClass: "__second-title" }, [
      _vm._v(_vm._s(_vm.$t("tradeOperator.tokenList")))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "token-list" },
      _vm._l(_vm.tokenList, function(token, i) {
        return _c("token-card", { key: i, attrs: { token: token } })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }